

import React from 'react'
import { ButtonWrapper } from './style';

function Button({title="Button",loading=false,disabled=false,onClick=()=>{}, className=""}) {
  const isDisabled = loading || disabled;
  return (
    <ButtonWrapper onClick={onClick} disabled={isDisabled} className={isDisabled?"disabled "+className:className}>
        {!loading?title:<div className='loader'></div>}
    </ButtonWrapper>
  )
}

export default Button;